export const getReadableFileSize = (size) => {
  const mb = 1024 * 1024;

  if (size < mb) {
    return I18n.t("common.size.less_than_mb");
  }

  return `${Math.floor(size / mb)}mb`;
}